document.addEventListener('DOMContentLoaded', function () {
  initMobileNav();
  initAnnouncement();
  initAccordions();
  initProductGallery();
  initVariantPicker();
  initQuantityStepper();
  initStickyAddToCart();
  initCartDrawer();
  initCollectionControls();
  initRecommendations();
  initScrollReveal();
  initCartReviews();
});

var cartReviewsTimer = null;

function initAnnouncement() {
  var bar = document.querySelector('[data-announcement]');
  if (!bar) return;
  var messages = bar.querySelectorAll('.announcement-bar__message');
  if (messages.length < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var index = 0;
  window.setInterval(function () {
    messages[index].classList.remove('is-active');
    index = (index + 1) % messages.length;
    messages[index].classList.add('is-active');
  }, 4500);
}

function initCartReviews() {
  if (cartReviewsTimer) {
    window.clearInterval(cartReviewsTimer);
    cartReviewsTimer = null;
  }
  var wrap = document.querySelector('[data-cart-reviews]');
  if (!wrap) return;
  var track = wrap.querySelector('[data-cart-reviews-track]');
  if (!track || track.children.length < 2) return;
  var seconds = parseInt(wrap.getAttribute('data-interval'), 10);
  if (!seconds || seconds <= 0) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var paused = false;
  ['mouseenter', 'focusin', 'touchstart'].forEach(function (evt) {
    track.addEventListener(evt, function () { paused = true; }, { passive: true });
  });
  ['mouseleave', 'focusout'].forEach(function (evt) {
    track.addEventListener(evt, function () { paused = false; });
  });
  cartReviewsTimer = window.setInterval(function () {
    if (paused || !document.body.contains(track)) return;
    var index = Math.round(track.scrollLeft / track.clientWidth);
    var next = (index + 1) % track.children.length;
    track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
  }, seconds * 1000);
}

function initScrollReveal(root) {
  var items = (root || document).querySelectorAll('[data-reveal]:not(.is-revealed)');
  if (!items.length) return;

  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (el) { el.classList.add('is-revealed'); });
    return;
  }

  var groups = {};
  items.forEach(function (el) {
    var group = el.getAttribute('data-reveal-group') || 'default';
    groups[group] = groups[group] || [];
    groups[group].push(el);
  });

  var observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var group = el.getAttribute('data-reveal-group') || 'default';
      var index = groups[group].indexOf(el);
      var delay = Math.max(0, index % 6) * 90;
      setTimeout(function () { el.classList.add('is-revealed'); }, delay);
      obs.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  items.forEach(function (el) { observer.observe(el); });
}

function initMobileNav() {
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', function () {
    var isOpen = !nav.hidden;
    nav.hidden = isOpen;
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });
}

function initAccordions() {
  document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
    accordion.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.accordion-item');
        var wasOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !wasOpen);
        trigger.setAttribute('aria-expanded', String(!wasOpen));
      });
    });
  });
}

function initProductGallery() {
  var gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;
  var viewer = gallery.querySelector('[data-gallery-viewer]');
  var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
  var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
  if (!viewer || slides.length === 0) return;

  function setActiveThumb(index) {
    thumbs.forEach(function (t, i) {
      if (i === index) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
  }

  thumbs.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () {
      var slide = slides[index];
      if (!slide) return;
      viewer.scrollTo({ left: slide.offsetLeft - viewer.offsetLeft, behavior: 'smooth' });
      setActiveThumb(index);
    });
  });

  if (thumbs.length > 1 && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var index = slides.indexOf(entry.target);
          if (index !== -1) setActiveThumb(index);
        }
      });
    }, { root: viewer, threshold: 0.6 });
    slides.forEach(function (slide) { observer.observe(slide); });
  }
}

function initQuantityStepper() {
  document.querySelectorAll('.quantity-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('[data-quantity-input]');
    var decrease = stepper.querySelector('[data-quantity-decrease]');
    var increase = stepper.querySelector('[data-quantity-increase]');
    if (!input) return;

    function clamp(value) {
      var min = Number(input.getAttribute('min')) || 1;
      return Math.max(min, value);
    }
    if (decrease) decrease.addEventListener('click', function () { input.value = clamp((parseInt(input.value, 10) || 1) - 1); });
    if (increase) increase.addEventListener('click', function () { input.value = clamp((parseInt(input.value, 10) || 1) + 1); });
    input.addEventListener('change', function () { input.value = clamp(parseInt(input.value, 10) || 1); });
  });
}

function initStickyAddToCart() {
  var stickyBar = document.querySelector('[data-sticky-bar]');
  var mainForm = document.getElementById('ProductForm');
  var mainButton = mainForm ? mainForm.querySelector('[data-add-to-cart]') : null;
  var stickyButton = document.querySelector('[data-sticky-add-to-cart]');
  if (!stickyBar || !mainButton || !stickyButton) return;

  stickyButton.addEventListener('click', function () { mainButton.click(); });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.hidden = !(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(mainButton);
  }
}

function initVariantPicker() {
  var form = document.getElementById('ProductForm');
  if (!form) return;
  var variantsScript = document.querySelector('[data-product-variants]');
  var optionSelects = form.querySelectorAll('[data-product-option]');
  if (!variantsScript || optionSelects.length === 0) return;

  var variants = JSON.parse(variantsScript.textContent);
  var variantIdInput = form.querySelector('[data-variant-id]');
  var submitButton = form.querySelector('[data-add-to-cart]');
  var availableLabel = submitButton ? submitButton.textContent.trim() : '';

  function currentSelection() {
    return Array.from(optionSelects)
      .sort(function (a, b) { return Number(a.getAttribute('data-product-option')) - Number(b.getAttribute('data-product-option')); })
      .map(function (select) { return select.value; });
  }

  function findMatchingVariant(selection) {
    return variants.find(function (variant) {
      var options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      return options.every(function (value, index) { return value === selection[index]; });
    });
  }

  function updateForSelection() {
    var match = findMatchingVariant(currentSelection());
    if (!match) return;
    variantIdInput.value = match.id;

    var label = match.available ? availableLabel : 'Épuisé';
    if (submitButton) { submitButton.disabled = !match.available; submitButton.textContent = label; }
    var stickyButton = document.querySelector('[data-sticky-add-to-cart]');
    if (stickyButton) { stickyButton.disabled = !match.available; stickyButton.textContent = label; }

    document.querySelectorAll('[data-product-price], .product-sticky-bar__price').forEach(function (el) {
      el.textContent = formatMoney(match.price);
    });
    var compareEl = document.querySelector('.product-buybox__compare');
    if (compareEl) {
      var onSale = match.compare_at_price && match.compare_at_price > match.price;
      compareEl.textContent = onSale ? formatMoney(match.compare_at_price) : '';
      compareEl.hidden = !onSale;
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url.toString());
  }

  optionSelects.forEach(function (select) { select.addEventListener('change', updateForSelection); });
}

function formatMoney(cents) {
  return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    })
    .catch(function () {});
}

function initCartDrawer() {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || !window.theme) return;

  function openDrawer() {
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.hidden = true;
    document.body.style.overflow = '';
  }

  function bindDrawerControls() {
    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    drawer.querySelectorAll('[data-cart-quantity-decrease]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = drawer.querySelector('[data-cart-quantity-input][data-line="' + btn.getAttribute('data-line') + '"]');
        changeLine(btn.getAttribute('data-line'), Math.max(0, (parseInt(input.value, 10) || 1) - 1));
      });
    });
    drawer.querySelectorAll('[data-cart-quantity-increase]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = drawer.querySelector('[data-cart-quantity-input][data-line="' + btn.getAttribute('data-line') + '"]');
        changeLine(btn.getAttribute('data-line'), (parseInt(input.value, 10) || 1) + 1);
      });
    });
    drawer.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeLine(btn.getAttribute('data-line'), 0); });
    });
    drawer.querySelectorAll('[data-cart-upsell-add]').forEach(function (btn) {
      btn.addEventListener('click', function () { addToCart(btn.getAttribute('data-variant-id'), 1); });
    });
  }

  document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openDrawer();
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !drawer.hidden) closeDrawer();
  });

  function refreshDrawer(then) {
    fetch(window.theme.routes.cart_url + '?section_id=cart-drawer')
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newPanel = doc.querySelector('[data-cart-drawer] .cart-drawer__panel');
        var currentPanel = drawer.querySelector('.cart-drawer__panel');
        if (newPanel && currentPanel) {
          currentPanel.innerHTML = newPanel.innerHTML;
          bindDrawerControls();
          initCartReviews();
        }
        updateCartCount();
        if (then) then();
      })
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: quantity })
    }).then(function () { refreshDrawer(); });
  }

  function addToCart(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function () { refreshDrawer(openDrawer); })
      .catch(function () {});
  }

  // Délégation : couvre aussi les formulaires injectés plus tard (recommandations)
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-add-to-cart-form]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('[data-add-to-cart]');
    var originalLabel = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Ajout…'; }

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (button) { button.disabled = false; button.textContent = originalLabel; }
        if (data.status) return;
        refreshDrawer(openDrawer);
      })
      .catch(function () {
        if (button) { button.disabled = false; button.textContent = originalLabel; }
      });
  });

  bindDrawerControls();
}

function initRecommendations() {
  var section = document.querySelector('[data-product-recommendations]');
  if (!section || section.querySelector('.product-grid')) return;
  var url = section.getAttribute('data-url');
  if (!url) return;
  fetch(url)
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-product-recommendations]');
      if (fresh && fresh.innerHTML.trim().length) {
        section.innerHTML = fresh.innerHTML;
        initScrollReveal(section);
      }
    })
    .catch(function () {});
}

function initCollectionControls() {
  var sortSelect = document.querySelector('[data-collection-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  var filterForm = document.querySelector('[data-collection-filter-form]');
  if (filterForm) {
    var applyFilters = function () {
      var url = new URL(window.location.href);
      var params = new URLSearchParams();
      var sortBy = url.searchParams.get('sort_by');
      if (sortBy) params.set('sort_by', sortBy);
      filterForm.querySelectorAll('[data-collection-filter-input]').forEach(function (input) {
        if (input.type === 'checkbox') {
          if (input.checked) params.append(input.name, input.value);
        } else if (input.value !== '') {
          params.append(input.name, input.value);
        }
      });
      window.location.href = url.pathname + '?' + params.toString();
    };
    filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
      checkbox.addEventListener('change', applyFilters);
    });
    filterForm.addEventListener('submit', function (event) {
      event.preventDefault();
      applyFilters();
    });
  }
}
